// @flow
import React, {Component} from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';
import createDebugger from 'debug';
import DATE_CONSTANTS from 'trustar-2.0/utils/Date.constants';
const debug = createDebugger('app:components:DateRangePresets'); // eslint-disable-line no-unused-vars
import {
  Icon,
  IconLookup,
} from 'trustar-2.0/components';
import { DefaultTheme } from 'trustar-2.0/themes';
import type { ThemeType } from 'trustar-2.0/types';


// Style
const StyledDateRangePresets = styled.div`
  display: inline-flex;
  justify-content: space-evenly;
  padding: 0.25rem 0;
  
  span {
    margin-right: 0.25rem;
    min-width: 2rem;
    text-align: center;
    font-size: ${({theme}) => theme.FontSizes.P};
    
    &:hover {
      cursor: pointer;
      font-weight: bold;
    }
  }
`;

const initialValues = {
  options: DATE_CONSTANTS.DATE_PRESET_DEFAULTS,
  theme: DefaultTheme,
};

// Bindings
type DateRangePresetsProps = {
  options: Array<any>,
  onSelectOption: Function,
  selectedPreset?: string,
  theme: ThemeType,
};

class DateRangePresets extends Component {
  props: DateRangePresetsProps;
  static defaultProps = initialValues;

//  ----Template----

  render() {
    const presets = this.props.options;
    return (
      <StyledDateRangePresets>
        {presets.map((option, index) => {
          return (<span
            key={index}
            style={{fontWeight: this.props.selectedPreset === option.label ? 'bold' : 'initial'}}
            onClick={(e) => this.selectPreset(option)}>
            {option.label}
          </span>);
        })}
      </StyledDateRangePresets>
    );
  }

// ----Lifecycle Hooks----

// ----Methods----

  selectPreset = (option: Object) => {
    this.props.onSelectOption(option);
  };
}

// Logic & Helper Components

// export default connect(mapStateToProps, dispatchProps)(DateRangePresets);

export {DateRangePresets};


// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/components/DatePicker/DateRangePresets.js